import React, { useEffect, useState } from "react";
import { Button, Form, FormSelect, Modal } from "react-bootstrap";
import { PlusCircleOutlined } from "../../../helpers/icons/antDesignIcons";
import useTranslation from "../../../hooks/useTranslation";

const AddContainer = ({ handleAddNewContainerClick, siteList }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [siteId, setSiteId] = useState("");
  const [containerName, setContainerName] = useState("");
  const [containerType, setContainerType] = useState("");
  const { t } = useTranslation("common");

  return (
    <div className="add-site__wrapper">
      <Button
        variant="contained"
        color="primary"
        className="locations-page__header__add__btn btn-table-feature"
        onClick={() => setModalIsOpen(true)}
      >
        <PlusCircleOutlined />
        {t("container")}
      </Button>
      <Modal centered show={modalIsOpen} onHide={() => setModalIsOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title> {t("addNewContainer")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="add-site__form">
            <FormSelect
              className="mb-3"
              onChange={(e) => setSiteId(e.target.value)}
              required
            >
              <option value="">{t("selectSite")}</option>
              {siteList.map((site) => (
                <option key={site._id} value={site._id}>
                  {site.sitename}
                </option>
              ))}
            </FormSelect>
            <Form.Group className="mb-3">
              <Form.Label>{t("containerName")}</Form.Label>
              <Form.Control
                type="text"
                placeholder="Minta: Magtár 1"
                required
                onChange={(e) => setContainerName(e.target.value)}
              />
            </Form.Group>
            <FormSelect
              className="mb-3"
              onChange={(e) => setContainerType(e.target.value)}
            >
              <option value="">{t("containerType")}</option>
              <option value="Magtár">{t("granary")}</option>
              <option value="Siló">{t("silo")}</option>
            </FormSelect>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalIsOpen(false)}>
            {t("cancel")}
          </Button>
          <Button
            variant="primary"
            type="submit"
            onClick={() =>
              handleAddNewContainerClick({
                siteId,
                containerName,
                containerType,
              })
            }
          >
            {t("add")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddContainer;
